const commentItems = [
  {
    name: '影迷小林',
    time: '3天前',
    content: '用了7777影院快两年了，片源真的很全，连一些很小众的文艺片都能找到。播放速度也快，基本不卡。强烈推荐给所有爱看电影的朋友！',
    likes: 128,
  },
  {
    name: '追剧达人阿杰',
    time: '5天前',
    content: '追《长安夜未央》就是在这里追的，每天同步更新，再也不用等第二天了。多线路切换功能太实用了，高峰期也不怕。',
    likes: 96,
  },
  {
    name: '小丸子爱吃糖',
    time: '1周前',
    content: '为了看《时空穿梭者》找到了这个站，没想到资源这么全。画质超清，投屏到电视上看效果很棒，已经安利给身边同事了。',
    likes: 73,
  },
  {
    name: '深夜电影人',
    time: '1周前',
    content: '作为一个重度电影爱好者，7777影院的片库深度让我很惊喜。从法国新浪潮到日本动画，分类做得很细致，找片效率很高。纯净无广告体验是真的好。',
    likes: 54,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap mb-3">
            用户声音
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            影迷怎么说
          </h2>
          <p className="text-foreground-600 text-sm mt-2">来自真实用户的观影体验分享</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-700 text-sm font-bold font-heading">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}